'use strict';

import _cloneDeep from "lodash/cloneDeep";
import React, { Component } from 'react';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import handleChange from 'Components/Forms/Functions/handleChange';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Checkbox from 'Components/Forms/Elements/Checkbox';
import Select from 'Components/Forms/Elements/Select';
import SearchcityField from 'Components/Front/SearchcityField';
import AskUserLocation from 'Components/Front/AskUserLocation';
import bemit from 'Functions/bemit';
import { coworking_place_types } from 'Shared/options';
import { getUrlParameter } from 'Shared/utilities';
const widget_types = [{
  label: 'Tous nos espaces',
  value: 'all'
}].concat(coworking_place_types.map(function (opt) {
  return {
    label: opt.widget_label,
    value: opt.new_value
  };
}));
const {
  app
} = window;
function getValues(props) {
  const state = {};
  if (props['default-values']) {
    const values = props['default-values'];
    state['widget-date'] = values.date;
    state['widget-space-type'] = values['space-type'] || widget_types[0].value;
    if (values.research) {
      state.research = _cloneDeep(values.research);
    }
  } else {
    state['widget-date'] = window.localStorage.getItem('widget-date') || '';
    state['widget-space-type'] = window.localStorage.getItem('widget-space-type') || widget_types[0].value;
  }
  return state;
}
export default class SearchWidget extends Component {
  state = {
    loading: false,
    search_id: uniqid(),
    space_type_id: uniqid(),
    roles: app.state.session.user?.roles || [],
    'widget-around-me': getUrlParameter('mode') === 'autour',
    ask_user_location: getUrlParameter('mode') === 'autour',
    status_messages: {},
    cities: [],
    ...getValues(this.props)
  };
  handleChange = ({
    e,
    value,
    name,
    ...params
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (app.state.session.fetched) {
      component.setState({
        roles: app.state.session.user?.roles || []
      });
    }
    if (name === 'widget-date') {
      window.localStorage.setItem('widget-date', value);
    } else if (name === 'widget-space-type') {
      window.localStorage.setItem('widget-space-type', value);
    } else if (name === 'research') {
      if (value?.value && value.value.includes('#')) {
        component.setState({
          raw_search: value.value.split('#')[0]
        });
      }
    }
    handleChange.bind(this)({
      e,
      value,
      name,
      ...params
    });
    if (typeof props.onChange === 'function') {
      props.onChange({
        e,
        value,
        name,
        ...params
      });
    }
  };
  handleRawSearchChange = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      raw_search: e?.target?.value || ''
    });
  };
  handleSearchedChange = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.search_timout) {
      component.clearTimeout(component.search_timout);
    }
    const {
      value = '',
      name = ''
    } = e.target || {};
    component.setState({
      [name]: value
    });
    component.search_timout = window.setTimeout(function () {
      component.search_timout = undefined;
      component.setState({
        ['delayed_' + name]: value
      });
    });
  };
  buildSearchedURL = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let search_url = '/recherche/';
    let type = state['widget-space-type'];
    if (!type || type === 'all') {
      type = 'tous';
    } else if (type === 'b_seminar') {
      type = 'seminaires';
    }
    search_url += type ? type + '/' : widget_types[0].value + '/';
    if (state['widget-around-me'] === true) {
      if (search_url.endsWith('/')) {
        search_url = search_url.slice(0, -1);
      }
      search_url += '?mode=autour';
    } else if (props.search_mode === 'raw' || state.research?.value) {
      search_url += state.research?.value;
    } else {
      search_url += state.raw_search + '?mode=recherche';
    }
    return search_url;
  };
  handleSubmit = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.preventDefault();
    if (!state.raw_search && !state['widget-around-me'] && (!state.research || !state.research.value)) {
      return component.setState({
        status_messages: {
          ...state.status_messages,
          research: {
            error: 'Sélectionnez une ville'
          }
        }
      });
    }
    window.localStorage.setItem('widget-space-type', state['widget-space-type'] || 'coworking');
    app.navigateTo(component.buildSearchedURL());
  };
  askUserLocation = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      ask_user_location: true
    });
  };
  handleUserLocated = result => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!result || !result.coords) {
      return component.handleUserLocationRefused(result);
    }
    const {
      latitude,
      longitude
    } = result.coords;
    component.setState({
      ask_user_location: false,
      user_location: {
        latitude,
        longitude
      }
    });
    if (typeof props.onUserLocated) {
      props.onUserLocated({
        latitude,
        longitude
      });
    }
  };
  handleUserLocationRefused = infos => {
    const component = this,
      props = this.props,
      state = this.state;
    console.error(infos);
    component.setState({
      ask_user_location: false,
      user_location: null
    });
    if (props.onUserLocationRefused) {
      props.onUserLocationRefused(infos);
    }
  };
  handleAroundMeChange = ({
    e,
    name,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      'widget-around-me': value === true
    });
  };
  handleLocationTimeout = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.onLocationTimeout) props.onLocationTimeout();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const modifiers = (props.bemit || []).slice(0);
    if (state['widget-around-me'] === true) {
      modifiers.push('hide-city');
    }
    if (state.research?.value) {
      const city_value = state.research.value;
      const selected = !city_value.includes('#') ? false : city_value.split('#').length > 1 ? city_value.split('#')[0].startsWith(state.raw_search) : false;
      if (selected) modifiers.push('city-selected');
    }
    const type_selection = state.roles.includes('company_employee') === false ? /*#__PURE__*/React.createElement("div", {
      className: "c-widget__element choice"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: state.space_type_id + '-type',
      className: "c-widget__label"
    }, "Type"), /*#__PURE__*/React.createElement(Select, {
      className: "c-widget__select",
      id: state.space_type_id + '-type',
      name: "widget-space-type",
      onChange: component.handleChange,
      value: state['widget-space-type'],
      options: widget_types,
      status: state.status_messages
    })) : undefined;
    let output = /*#__PURE__*/React.createElement("form", {
      method: "GET",
      action: component.buildSearchedURL(),
      className: bemit('c-widget', modifiers),
      onSubmit: component.handleSubmit,
      autoComplete: "off"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-widget__element date"
    }, /*#__PURE__*/React.createElement("span", {
      className: "c-widget__label"
    }, "Date"), /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      id: state.space_type_id + '-date',
      value: state['widget-date'],
      name: "widget-date",
      "allow-no-value": true,
      "no-past": true,
      status: state.status_messages,
      "btn-class": bemit('c-flat-btn', ['primary', 'front', 'date'])
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-widget__element city"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-widget__city-element"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: state.space_type_id + '-city',
      className: "c-widget__label"
    }, "Ville"), /*#__PURE__*/React.createElement(SearchcityField, {
      id: state.space_type_id + '-city',
      name: "research",
      onChange: component.handleChange,
      onType: component.handleRawSearchChange,
      status: state.status_messages,
      "initial-value": state.research,
      "read-only": state['widget-around-me'] === true
    })), /*#__PURE__*/React.createElement(Checkbox, {
      onChange: component.handleAroundMeChange,
      className: "c-widget__around-me",
      value: state['widget-around-me'],
      name: "widget-around-me",
      label: "Autour de moi (30km)",
      "full-width": true,
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(AskUserLocation, {
      onSuccess: component.handleUserLocated,
      onError: component.handleUserLocationRefused,
      ask: state.ask_user_location,
      onTimeout: component.handleLocationTimeout
    })), type_selection, /*#__PURE__*/React.createElement("div", {
      className: "c-widget__element validate"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      className: bemit('c-flat-btn', ['front', 'blue', 'front-search'])
    }, "Rechercher")));
    return output;
  }
}
